import React from 'react';

function CartasClientes(props) {

    return (
  <div className="row d-flex justify-content-between">
  <div className="col-xl-4 d-flex justify-content-start col-sm-3 col-12 mb-3">
    <div className="card bg-card-info" style={{height:'98px',width:'80%'}}>
      <div className='card-header' style={{height:'80%'}}>
        Almacen
      </div>
      <div className="card-body bg-light mx-1 mb-1">
        <div className="d-flex justify-content-between px-md-1">
        
        </div>
      </div>
    </div>
  </div>
  <div className="col-xl-4 d-flex justify-content-center col-sm-3 col-12 mb-3">
    <div className="card bg-card-info" style={{height:'98px',width:'80%'}}>
      <div className='card-header' style={{height:'80%'}}>
        Almacen
      </div>
      <div className="card-body bg-light mx-1 mb-1">
        <div className="d-flex justify-content-between px-md-1">
         
        </div>
      </div>
    </div>
  </div>
  <div className="col-xl-4 d-flex justify-content-end col-sm-3 col-12 mb-3">
    <div className="card bg-card-info" style={{height:'98px',width:'80%'}}>
      <div className='card-header' style={{height:'80%'}}>
        Almacen
      </div>
      <div className="card-body bg-light mx-1 mb-1">
        <div className="d-flex justify-content-between px-md-1">
         
        </div>
      </div>
    </div>
  </div>
</div>

  );
}

export default CartasClientes;


// WEBPACK FOOTER //
// ./src/components/ventas/cartas/cartas.js